import CtaCard from "@/components/ctaCard";
import { CONSTANTS } from "./constants";

const ServiceByOneMind = () => {
  return <CtaCard {...CONSTANTS} />;
};

export default ServiceByOneMind;
